let cartNoteTyping;

function validateQty(qty) {
  if (parseFloat(qty) == parseInt(qty, 10) && !isNaN(qty)) {
    return qty;
  }
  return 1;
}

const countryList = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, the Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curacao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People's Republic of",
  KR: "Korea, Republic of",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, the Former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  CS: "Serbia and Montenegro",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan, Province of China",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.s.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

let convertShippingAmount = freeShippingBarAmount;
function checkShippingAvailablity() {
  let selectedCountry = Shopify.country;
  let shippingCountriesContainer = $("#shippingcountries");
  if (shippingCountriesContainer.length == 0) {
    shippingCountriesContainer = $("#shippingCountry");
  }
  if (
    shippingCountriesContainer &&
    shippingCountriesContainer.find("option").length > 0
  ) {
    let shippingSelectedCountry = countryList[selectedCountry];
    if (
      shippingCountriesContainer.find(
        'option[value="' + shippingSelectedCountry + '"]'
      ).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

function freeShippingBar(cart) {
  let countryAvailable = checkShippingAvailablity();
  let shippingBarContainer = $("[data-free-shipping-container]");
  if (countryAvailable && shippingBarContainer.length > 0) {
    if (cart.item_count == 0) {
      shippingBarContainer.addClass("hidden");
      return false;
    }
    let cartPrice = cart.total_price;
    let shippending = Shopify.formatMoney(
      convertShippingAmount - cartPrice,
      moneyFormat
    );
    let shippingPercentage = parseFloat(
      (cartPrice * 100) / convertShippingAmount
    ).toFixed(2);
    if (shippingPercentage > 10 && shippingPercentage < 100) {
      shippingPercentage = shippingPercentage - 5;
    } else if (shippingPercentage > 100) {
      shippingPercentage = 100;
    }
    if ($("[data-free-shipping-text]").length > 0) {
      $("[data-free-shipping-text]").each(function () {
        const $text = $(this);
        if (shippingPercentage >= 100) {
          $text.html(freeShippingBarSuccessText);
        } else {
          const template = freeShippingBarText || "";
          if (template.indexOf("||amount||") > -1) {
            const parts = template.split("||amount||");
            $text.html(
              parts[0] + "<strong>" + shippending + "</strong>" + (parts[1] || "")
            );
          } else {
            $text.text(template.replace("||amount||", shippending));
          }
        }
      });
    }

    if ($("[data-free-shipping-bar]").length > 0) {
      $("[data-free-shipping-bar]").css("width", shippingPercentage + "%");
    }
    shippingBarContainer.removeClass("hidden");
  }
}

let favicon = false;

function browserTabNotification() {
  if (browserNotificationStatus) {
    favicon = new Favico({
      animation: "pop",
      bgColor: browserNotificationBg,
      textColor: browserNotificationText,
      type: browserNotificationShape,
    });
  }
}

$(document).ready(function () {
  browserTabNotification();
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  if (freeShippingBarStatus) {
    if (Shopify.currency.active != shopCurrency) {
      let shippingAmount = parseInt(freeShippingBarAmount);
      if (shippingAmount != undefined) {
        convertShippingAmount = parseFloat(
          (shippingAmount * Shopify.currency.rate).toFixed(2)
        );
      }
    }
  }
});

$(document).on("keydown", "[name=note]", function (e) {
  clearTimeout(cartNoteTyping);
});

$(document).on("keyup ", "[name=note]", function () {
  const $note = $(this);
  clearTimeout(cartNoteTyping);
  cartNoteTyping = setTimeout(function () {
    const currentVal = $note.val();
    $.ajax({
      url: cartUpdateUrl,
      type: "POST",
      data: { note: currentVal },
      dataType: "json",
      success: function () {},
    });
  }, 750);
});

function getCartQtyInput($el) {
  const $scope = $el.closest("[data-greez-cart-qty]");
  if ($scope.length) {
    return $scope.find('input[name="updates[]"]');
  }
  return $el.siblings('input[name="updates[]"]');
}

function syncGreezQtySelectorState(line, quantity) {
  const $input = $('[name="updates[]"][data-line="' + line + '"]');
  const $selector = $input.closest("[data-greez-cart-qty]");
  if (!$selector.length) {
    return;
  }
  let qty = parseInt(quantity, 10);
  if (isNaN(qty)) {
    qty = parseInt($input.val(), 10) || 0;
  }
  $selector.toggleClass("is-qty-one", qty <= 1);
  $selector
    .closest("[data-cart-line-item]")
    .toggleClass("greez-cart-item--qty-one", qty <= 1);
  const $downBtn = $selector.find(".greez-cart-qty-selector__btn--down");
  if ($downBtn.length) {
    $downBtn.attr(
      "aria-label",
      qty <= 1
        ? $downBtn.attr("data-remove-label")
        : $downBtn.attr("data-decrease-label")
    );
  }
}

function updateCartUI(cart) {
  if (window.location.pathname.indexOf("/cart") > -1) {
    cartPageUpdate(cart);
  } else if (
    typeof cartDrawerEnable !== "undefined" &&
    cartDrawerEnable &&
    document.querySelector("[data-greez-cart-drawer]")
  ) {
    buildCart(cart, $("body").hasClass("yv_side_Drawer_open"));
  }
  if (window.GreezCartShippingReward) {
    window.GreezCartShippingReward.update(cart);
  }
}

changeCartItem = function (line, quantity) {
  const params = {
    type: "POST",
    url: cartChangeUrl,
    data: "quantity=" + quantity + "&line=" + line,
    dataType: "json",
    success: function (cart) {
      if (cart.item_count == 0) {
        emptyCartStatus = true;
        $("[data-cart-count]").hide();
      } else {
        emptyCartStatus = false;
        cartItemsCount = cart.item_count;
        if (favicon) {
          favicon.badge(cartItemsCount);
        }
        $("[data-cart-count]").show();

        const item = cart.items[line - 1];
        if (item) {
          $('[name="updates[]"][data-line="' + line + '"]').val(item.quantity);
          syncGreezQtySelectorState(line, item.quantity);
        }
      }
      updateCartUI(cart);
    },
    error: function () {
      jQuery.getJSON(cartUrl, function (cart) {
        if (quantity == 0) {
          $('[name="updates[]"][data-line="' + line + '"]')
            .closest("[data-cart-line-item]")
            .remove();
        }
        cartItemsCount = cart.item_count;
        if (favicon) {
          favicon.badge(cartItemsCount);
        }
        if (cart.item_count == 0) {
          $("[data-cart-count]").hide();
        } else {
          $("[data-cart-count]").show();

          const item = cart.items[line - 1];
          if (item) {
            $('[name="updates[]"][data-line="' + line + '"]').val(
              item.quantity
            );
            syncGreezQtySelectorState(line, item.quantity);
          }
        }
        updateCartUI(cart);
      });
    },
  };
  jQuery.ajax(params);
};

$(document).on("click", ".line_item_change", function (evt) {
  evt.preventDefault();
  const $el = $(this);
  const line = $el.data("line");
  const parent = $el.closest("[data-cart-line-item]");
  const $qtySelector = getCartQtyInput($el);
  const step = parseInt($qtySelector.attr("step") || 1, 10);
  $("#cartItemError-" + line).html("");
  let qty = parseInt($qtySelector.val().replace(/\D/g, ""), 10);
  parent.addClass("disabled");
  parent.closest("[data-cart-items]").addClass("disabled");
  qty = validateQty(qty);
  if ($el.hasClass("quantity-up")) {
    qty += step;
  } else {
    qty -= step;
    if (qty <= 0) qty = 0;
  }
  $qtySelector.val(qty);
  syncGreezQtySelectorState(line, qty);
  if (line) {
    changeCartItem(line, qty);
  }
});

$(document).on("change", '[name="updates[]"]', function (evt) {
  evt.preventDefault();
  const $el = $(this);
  const line = $el.data("line");
  const parent = $el.closest("[data-cart-line-item]");
  let qty = parseInt($el.val().replace(/\D/g, ""), 10);
  parent.addClass("disabled");
  parent.closest("[data-cart-items]").addClass("disabled");
  $("#cartItemError-" + line).html("");
  qty = validateQty(qty);
  if (line) {
    changeCartItem(line, qty);
  }
});

$(document).on("click", "[data-cart-clear]", function (evt) {
  evt.preventDefault();
  const $btn = $(this);
  if ($btn.prop("disabled")) {
    return;
  }
  $btn.prop("disabled", true);
  $("[data-cart-items]").addClass("disabled");
  fetch(typeof cartClearUrl !== "undefined" ? cartClearUrl : "/cart/clear.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      updateCartUI(cart);
    })
    .catch(function () {
      jQuery.getJSON(cartUrl, function (cart) {
        updateCartUI(cart);
      });
    })
    .finally(function () {
      $btn.prop("disabled", false);
    });
});

if (window.location.pathname.indexOf("/cart") > -1) {
  // Shipping Estimations
  (function () {
    function shippingEstimates() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        const country = document.getElementById("shippingCountry");
        if (!country) {
          return false;
        }
        new Shopify.CountryProvinceSelector(
          "shippingCountry",
          "shippingProvince",
          {
            hideElement: "shippingProvinceContainer",
          }
        );
        setupEventListeners();
      }
    }

    function setupEventListeners() {
      const button = document.getElementById("getShippingEstimates");
      if (button) {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          $("#ShippingWrapperResponse")
            .html("")
            .removeClass("success")
            .removeClass("error")
            .hide();
          const shippingAddress = {};
          shippingAddress.zip = jQuery("#shippingZip").val() || "";
          shippingAddress.country = jQuery("#shippingCountry").val() || "";
          shippingAddress.province = jQuery("#shippingProvince").val() || "";
          _getCartShippingRates(shippingAddress);
        });
      }
    }

    function _getCartShippingRates(shippingAddress) {
      const params = {
        type: "POST",
        url: "/cart/shipping_rates.json",
        data: jQuery.param({ shipping_address: shippingAddress }),
        success: function (data) {
          _render(data.shipping_rates);
        },
        error: _onError,
      };
      jQuery.ajax(params);
    }

    function _fullMessagesFromErrors(errors) {
      const fullMessages = [];
      jQuery.each(errors, function (attribute, messages) {
        jQuery.each(messages, function (index, message) {
          fullMessages.push(message);
        });
      });
      return fullMessages;
    }

    function _onError(XMLHttpRequest) {
      let data = {};
      try {
        data = JSON.parse(XMLHttpRequest.responseText);
      } catch (error) {
        data = {};
      }
      const feedback = _fullMessagesFromErrors(data).join(", ") + ".";
      $("#ShippingWrapperResponse")
        .html('<p class="error-text">' + feedback + "</p>")
        .addClass("error")
        .show();
    }

    function _render(response) {
      if (response && response.length > 0) {
        let html = '<p class="success-text">';
        response.forEach(function (shipping) {
          html += `<span><strong>${
            shipping.name
          }:</strong>${Shopify.formatMoney(
            shipping.price * 100,
            moneyFormat
          )}</span>`;
        });
        html += "</p>";
        $("#ShippingWrapperResponse").html(html).addClass("success").show();
      } else {
        $("#ShippingWrapperResponse")
          .html('<p class="error-text">' + notAvailableLabel + "</p>")
          .addClass("error")
          .show();
      }
    }
    setTimeout(function () {
      shippingEstimates();
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (result) {
          if (result.item_count > 0) {
            freeShippingBar(result);
            upsellCartProducts(result);
          }
        })
        .catch(function () {});
    }, 500);
    window.shippingEstimates = shippingEstimates;
  })();
} else {
  // POST to cart/change.js returns the cart in JSON
  changeItem = function (line, quantity, callback) {
    const params = {
      type: "POST",
      url: cartChangeUrl,
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      success: function (cart) {
        if (cart.item_count == 0) {
          emptyCartStatus = true;
          $("[data-cart-count]").hide();
        } else {
          emptyCartStatus = false;
          $("[data-cart-count]").show();
        }
        const item = cart.items[line - 1];
        if (item) {
          $('[name="updates[]"][data-line="' + line + '"]').val(item.quantity);
          syncGreezQtySelectorState(line, item.quantity);
        }
        if (window.GreezCartShippingReward) {
          window.GreezCartShippingReward.update(cart);
        }
        callback(cart);
      },
      error: function () {
        jQuery.getJSON(cartUrl, function (cart) {
          callback(cart);
        });
      },
    };
    jQuery.ajax(params);
  };

  updateQuantity = function (line, qty, callback) {
    isUpdating = true;
    setTimeout(function () {
      changeItem(line, qty, callback);
    }, 250);
  };

  function getvaluefromdataattribute(name) {
    return $('input[data-attr="' + name + '"]').val();
  }

  $("#Recipient-Checkbox").click(function () {
    if (!this.checked) {
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
    }
  });

  if (cartDrawerEnable) {
    // POST to cart/add.js returns the cart in JSON
    $("body").on("click", ".Sd_addProduct", function (evt) {
      evt.preventDefault();
      let submit = $(this);
      if (submit.prop("disabled") || submit.is("[disabled]")) {
        return;
      }
      let form = $(this).closest("form");
      // if (submit.hasClass("Sd_addProductSticky")) {
      //   form = jQuery("#" + submit.attr("form"));
      // }
      if (form.closest(".yv_side_drawer_wrapper").length == 0) {
        focusElement = submit;
      }
      let parentSection = form.closest(".shopify-section");
      let Email = $('input[data-attr="' + "email" + '"]').val();
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
      parentSection.find(".productErrors").hide().html("");
      submit.addClass("is-loading");
      if (form.closest(".yv_side_drawer_wrapper").length == 0) {
        $("[data-drawer-body]").html(preLoadLoadGif);
        $("body")
          .find("[data-side-drawer]")
          .attr("class", "yv_side_drawer_wrapper");
        $("body").find("[data-drawer-title]").html(cartTitleLabel);
        $("body").find("[data-side-drawer]").attr("id", "mini__cart");
        $("body").find("[data-side-drawer]").addClass("mini_cart");
      }
      let params = {
        type: "POST",
        url: cartAddUrl,
        data: form.serialize(),
        dataType: "json",
        success: function (line_item) {
          if (form.closest(".quick-add-popup").length > 0) {
            form.closest(".quick-add-popup")[0].classList.remove('show');
            form.closest("[quick-add-body]")[0].innerHTML = '';
            document.body.classList.remove('quick-add-popup-open');
          }
          if (form.closest(".yv_side_drawer_wrapper").length > 0) {
            $("[data-drawer-body]").html(preLoadLoadGif);
            $("body")
              .find("[data-side-drawer]")
              .attr("class", "yv_side_drawer_wrapper");
            $("body").find("[data-drawer-title]").html(cartTitleLabel);
            $("body").find("[data-side-drawer]").attr("id", "mini__cart");
            $("body").find("[data-side-drawer]").addClass("mini_cart");
          }
          $("body").removeClass("quickview-open");
          $("body").addClass("side_Drawer_open");
          if(document.getElementById('addToCartAlert')){
            document.getElementById('addToCartAlert').play();
          }
          if(hapticFeedbackStatus){
            const canVibrate = window.navigator.vibrate;
            if (canVibrate) window.navigator.vibrate(500);
          }
          jQuery.getJSON(cartUrl, function (cart, textStatus) {
            buildCart(cart, true);
            setTimeout(function () {
              submit.removeClass("is-loading");
            }, 1000);
          });
        },
        error: function (XMLHttpRequest, textStatus) {
          focusElement = "";
          if (typeof errorCallback === "function") {
            errorCallback(XMLHttpRequest, textStatus);
          } else {
            let errorContainer = parentSection.find(".productErrors");
            if (errorContainer.length > 0) {
              if(XMLHttpRequest.responseJSON.errors){
                let giftCardWrapper = form.find('[data-gift-card-box]');
                if(giftCardWrapper.length > 0 && XMLHttpRequest.responseJSON.errors['email']){
                  let errormessageWrapper = giftCardWrapper.find('[data-gift-card-errors]');
                  let giftCardEmail = giftCardWrapper.find('[type=email]');
                  errorContainer.html(giftCardEmail.attr('data-attr') +' '+  XMLHttpRequest.responseJSON.errors['email']).show();
                }
              }
              else{
                errorContainer.html(XMLHttpRequest.responseJSON.description).show();
              }
            }
          }
          setTimeout(function () {
            $(".Sd_addProductSticky").removeClass("is-loading");
            submit.removeClass("is-loading");
          }, 1000);
        },
      };
      jQuery.ajax(params);
    });

    // Update quantity based on input on change

    $(document).on("click", ".quantity-button", function (evt) {
      if ($(this).closest("[data-greez-cart-drawer]").length) {
        return;
      }
      evt.preventDefault();
      const $el = $(this);
      const parent = $el.closest(".media-link");
      const line = $el.data("line");
      const $qtySelector = $el.closest(".quantity").find(".ajaxcart__qty-num");
      const step = parseInt(
        $el.closest(".quantity").find('input[name="updates[]"]').attr("step") || 1,
        10
      );
      let qty = $qtySelector.val();
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      if (qty) {
        qty = parseInt(qty.replace(/\D/g, ""), 10);
      }
      qty = validateQty(qty);
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += step;
      } else {
        qty -= step;
        if (qty <= 0) qty = 0;
      }
      $qtySelector.val(qty);
      if (line) {
        updateQuantity(line, qty, buildCart);
      }
    });

    $(document).on("change", ".ajaxcart__qty-num", function (evt) {
      evt.preventDefault();
      const $el = $(this);
      const parent = $el.closest(".media-link");
      const line = $el.data("line");
      let qty = parseInt($el.val().replace(/\D/g, ""), 10);
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      qty = validateQty(qty);
      if (line) {
        updateQuantity(line, qty, buildCart);
      }
    });

    function openCartDrawer(element) {
      $("[data-drawer-body]").html(preLoadLoadGif);
      $("body").find("[data-drawer-title]").html(cartTitleLabel);
      $("body")
        .find("[data-side-drawer]")
        .attr("class", "yv_side_drawer_wrapper");
      $("body")
        .find("[data-side-drawer]")
        .attr("id", "mini__cart")
        .addClass("mini_cart");
      $("body").addClass("side_Drawer_open");
      if (document && document.documentElement) {
        document.documentElement.classList.add("side_Drawer_open");
      }
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        buildCart(cart, true, element);
      });
    }
    $("body").on("click", ".openCartDrawer", function (e) {
      e.preventDefault();
      openCartDrawer($(this));
    }); 

    $("body").on("keydown", ".openCartDrawer", function (e) {
      if (e.code.toUpperCase() === "SPACE") {
        e.preventDefault();
        openCartDrawer($(this));         
      }
    });

    $(document).on("click", ".sd_mini_removeproduct", function (evt) {
      if ($("[data-greez-cart-drawer]").length) {
        return;
      }
      evt.preventDefault();
      const $el = $(this);
      const parent = $el.closest(".media-link");
      const line = parseInt($el.attr("data-line"), 10);
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      if (line) {
        updateQuantity(line, 0, buildCart);
      }
    });

    $(document).on("click ", ".cartDrawerNote", function () {
      $(this).toggleClass("active");
      const textArea = $(this).siblings(".cartNoteContainer");
      textArea.slideToggle();
    });
  }
}

$("body").on("click", "#GiftWrapProduct", function () {
  const params = {
    type: "POST",
    url: cartAddUrl,
    data: { id: parseInt($(this).attr("data-product"), 10), quantity: 1 },
    dataType: "json",
    success: function () {
      jQuery.getJSON(cartUrl, function (cart) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          cartPageUpdate(cart);
        } else {
          buildCart(cart, true);
        }
      });
    },
    error: function () {
      jQuery.getJSON(cartUrl, function (cart) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          buildCart(cart, true);
        } else {
          cartPageUpdate(cart);
        }
      });
    },
  };
  jQuery.ajax(params);
});

cartPageUpdate = function (cart) {
  $.ajax({
    url: mainCartUrl,
    type: "GET",
    dataType: "html",
    success: function (result) {
      $("body")
        .find("[data-cart-wrapper]")
        .html($(result).find("[data-cart-wrapper]").html());
      $(".cart-section").find("a:first").trigger("focus");
      freeShippingBar(cart);
      upsellCartProducts(cart);
      if (typeof refreshCartPageProductRecommendations === "function") {
        refreshCartPageProductRecommendations(cart);
      }
      const stickyCheckout = document.querySelector("[data-cart-sticky-checkout]");
      const cartPage = document.querySelector(".greez-cart-page");
      if (cart.item_count === 0) {
        if (stickyCheckout) {
          stickyCheckout.classList.remove("is-visible");
          stickyCheckout.setAttribute("hidden", "");
          stickyCheckout.setAttribute("aria-hidden", "true");
        }
        if (cartPage) {
          cartPage.classList.remove("greez-cart-page--has-checkout");
        }
        document.documentElement.classList.remove("greez-cart-sticky-active");
      } else {
        if (cartPage) {
          cartPage.classList.add("greez-cart-page--has-checkout");
        }
        if (typeof initGreezCartStickyCheckout === "function") {
          initGreezCartStickyCheckout();
        } else if (typeof syncGreezCartStickyPrices === "function") {
          syncGreezCartStickyPrices();
        }
      }
      if (typeof updateCartDrawerCta === "function") {
        updateCartDrawerCta(cart);
      }
      window.shippingEstimates();
      if (animationStatus) {
        if (AOS) {
          AOS.refreshHard();
        }
      }
    },
  });
};

buildCart = function (cart, showCart, element) {
  if (cart.item_count === 0) {
    emptyCartStatus = true;
    $("[data-cart-count]").hide();
  } else {
    emptyCartStatus = false;
    $("[data-cart-count]").show();
  }
  cartItemsCount = cart.item_count;
  if(cartItemsCount > 0 && cartItemsCount < 100){
  $('[data-cart-count]').text(cart.item_count);
  }
  else{
    $('[data-cart-count]').text('');
  }
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  $("[data-drawer-body]").load(mainCartUrl + "?view=jsonData", function () {
    freeShippingBar(cart);
    if (window.GreezCartShippingReward) {
      window.GreezCartShippingReward.update(cart);
    }
    if (typeof updateCartDrawerCta === "function") {
      updateCartDrawerCta(cart);
    }
    upsellCartDrawerProducts(cart, "drawer");
    setTimeout(function () {
      if($("body").hasClass("yv_side_Drawer_open")){
        $("[data-drawer-side-header]").closest(".yv-upsell-drawer").addClass("active");
      }
    }, 1500);
    if (showCart) {
      $("body").addClass("yv_side_Drawer_open");
      if (document && document.documentElement) {
        document.documentElement.classList.add("yv_side_Drawer_open");
      }
      $(".wrapper-overlay").css({ display: "block" });
      focusElementsRotation($("[data-side-drawer]"));
      if (element) {
        focusElement = element;
      }
      $(document).find(".yv_side_drawer_wrapper").trigger("focus");
    }
    if (animationStatus) {
      if (AOS) {
        AOS.refreshHard();
      }
    }
  });
};

$(document).on("click","[data-drawer-side-header]",function(){
  $(this).closest(".yv-upsell-drawer").toggleClass('active');
});

function upsellCartDrawerProducts(cart) {
  if(cart.item_count != 0){
    if(document.querySelector("[data-drawer-side-content]")){
      let upsellContainer=document.querySelector("[data-drawer-side-content]");
      let intent=upsellContainer.getAttribute("data-related-products");
      if(intent != "product-list"){
        let productId=cart.items[0].product_id; 
        let limit=upsellContainer.getAttribute("data-limit");
        fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productId+"&limit="+limit+"&section_id=upsell-products&intent="+intent)
         .then(response => response.text())
         .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('#product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
               upsellContainer.innerHTML = recommendations.innerHTML;
                document.querySelector(".yv-upsell-drawer").classList.remove('hidden')
            }else{
              document.querySelector(".yv-upsell-drawer").classList.add('hidden')
            }
         });
      }
      else{
        if(upsellContainer.children.length > 0){
          document.querySelector(".yv-upsell-drawer").classList.remove('hidden')
        }
        else{
          document.querySelector(".yv-upsell-drawer").classList.add('hidden')
        }
      }
    }  
  }
}

function upsellCartProducts(cart) {
  if(cart.item_count != 0){
    if(document.querySelector("[data-cart-upsell-wrapper]")){
      let upsellWrapper=document.querySelector("[data-cart-upsell-wrapper]");
      let upsellContainer=upsellWrapper.querySelector("[data-cart-upsell]");
      let intent=upsellWrapper.getAttribute("data-related-products");
      if(intent != "product-list"){
        let productId=cart.items[0].product_id; 
        let limit=upsellWrapper.getAttribute("data-limit");
        fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productId+"&limit="+limit+"&section_id=upsell-products&intent="+intent)
         .then(response => response.text())
         .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('#product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              if(window.innerWidth >= 768 ){
                if(upsellContainer.classList.contains('flickity-enabled')){
                  let slider = Flickity.data(upsellContainer);
                  if(slider){
                    slider.destroy();
                     upsellContainer.innerHTML = recommendations.innerHTML;
                    upsellWrapper.classList.remove('hidden')
                    flickitySlider(jQuery(upsellContainer));
                  }
                }
                else{
                  upsellContainer.innerHTML = recommendations.innerHTML;
                  upsellWrapper.classList.remove('hidden')
                  flickitySlider(jQuery(upsellContainer));
                }
              }
              else{
                upsellContainer.innerHTML = recommendations.innerHTML;
                upsellWrapper.classList.remove('hidden')
              }
            }else{
              upsellWrapper.classList.add('hidden')
            }
         });
      }
      else{
        if(upsellContainer.classList.contains('flickity-enabled')){
            let slider = Flickity.data(upsellContainer);
            if(slider){
              slider.destroy();
            }
        }
        if(upsellContainer.children.length > 0){
          if(window.innerWidth >= 768 ){
              upsellWrapper.classList.remove('hidden')
              flickitySlider(jQuery(upsellContainer));
          }
          else{
              upsellWrapper.classList.remove('hidden')
          }
        }
        else{
          upsellWrapper.classList.add('hidden')
        }
      }
    }  
  }
}

updateCartDrawerCta = function (cart) {
  const cta = document.querySelector("[data-cart-drawer-cta]");
  if (!cta) return;

  const cartUrl = cta.getAttribute("data-cart-url");
  const checkoutUrl = cta.getAttribute("data-checkout-url");
  const labelEl = cta.querySelector("span");
  const labelVerify = cta.getAttribute("data-label-verify");
  const labelCheckout = cta.getAttribute("data-label-checkout");

  const applyDestination = function (destination) {
    if (destination === "checkout") {
      if (checkoutUrl) cta.setAttribute("href", checkoutUrl);
      if (labelEl && labelCheckout) labelEl.textContent = labelCheckout;
      return;
    }

    if (cartUrl) cta.setAttribute("href", cartUrl);
    if (labelEl && labelVerify) labelEl.textContent = labelVerify;
  };

  if (
    window.GreezAttribution &&
    typeof window.GreezAttribution.shouldOverrideCartDrawerCta === "function" &&
    window.GreezAttribution.shouldOverrideCartDrawerCta()
  ) {
    applyDestination(window.GreezAttribution.getCartDrawerOverrideDestination());
    return;
  }

  const threshold = parseInt(cta.getAttribute("data-cta-threshold-cents"), 10) || 0;
  if (!threshold || !cart) return;

  if (cart.total_price >= threshold) {
    applyDestination("cart");
    return;
  }

  applyDestination("checkout");
};

document.addEventListener("DOMContentLoaded", function () {
  if (typeof updateCartDrawerCta === "function") {
    updateCartDrawerCta();
  }
});
